import { Dialog, DialogContent, DialogTitle, Grid, Typography, Button, makeStyles, TextField, FormControl, Paper, DialogActions, Checkbox } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import Cookies from "js-cookie";
import { useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { customerModal } from "../../../../constants";

const useStyles = makeStyles(theme => ({
    mandatoryField: {
        color: '#FF304C',
        backgroundRepeat: 'no-repeat',
        backgroundOrigin: 'padding-box',
        paddingRight: '2px'
    },
    validateStyle: {
        color: '#f44336',
        fontSize: '12px',
        fontWeight: '100',
        marginTop: 20
    },
    paper: {
        background: 'none',
        width: '100%',
        margin: theme.spacing(1, 'auto'),
        padding: theme.spacing(2),
        boxShadow: 'none'
    },
    accordianExpandedTitle: {
        fontSize: '12px',
        lineHeight: '13px',
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: '600',
        fontFamily: 'Ubuntu, sans-serif',
        letterSpacing: '0px',
        color: '#2B0A3D',
        opacity: 1
    },
    inputField: {
        "&::placeholder": {
            fontSize: '12px',
            lineHeight: '20px',
            fontStyle: 'normal',
            fontVariant: 'normal',
            fontWeight: '400',
            fontFamily: 'Ubuntu, sans-serif',
            letterSpacing: '0px',
            color: '#828282',
            opacity: 1
        },
        marginTop: '13px',
        fontSize: '12px',
        lineHeight: '20px',
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: '400',
        fontFamily: 'Ubuntu, sans-serif',
        letterSpacing: '0px',
        color: '#828282',
        opacity: 1
    }
}))

const AddCustomerModal = ({ setIsOpenDialog, isOpenDialog, countries, addCustomer }) => {
    const classes = useStyles();
    const userId = localStorage.getItem('userId');
    const [, forceUpdate] = useState();
    const [customerData, setCustomerData] = useState([]);
    const [partyName, setPartyName] = useState('');
    const [email, setEmail] = useState('');
    const [zip, setZip] = useState('');
    const [state, setState] = useState('');
    const [telephone, setTelephone] = useState('');
    const [country, setCountry] = useState([]);
    const formValidator = useRef(new SimpleReactValidator({}));

    const handleChangeCustomer = (field, value) => {
        setCustomerData(values => ({ ...values, [field]: value }));
    }

    const handleSave = () => {
        const isValid = formValidator.current.allValid();
        if (isValid) {
            const payload = { ...customerModal };
            payload.party_name = partyName;
            payload.contact_email = email;
            payload.contact_name = customerData.contact_name ? customerData.contact_name : '';
            payload.contact_phone = telephone;
            payload.party_addr1 = customerData.party_addr1 ? customerData.party_addr1 : '';
            payload.party_addr2 = customerData.party_addr2 ? customerData.party_addr2 : '';
            payload.party_city = customerData.party_city ? customerData.party_city : '';
            payload.party_state = state;
            payload.party_zipcode = zip;
            payload.party_ein = customerData.party_ein ? customerData.party_ein : '';
            payload.party_vatno = customerData.party_vatno ? customerData.party_vatno: '';
            payload.party_addr3 = '';
            payload.party_addr4 = '';
            payload.user = userId;
            payload.password = '';
            payload.party_country = country.ctrycode;
            addCustomer(payload);
        } else {
            formValidator.current.showMessages();
            forceUpdate(1);
        }       
    }

    const handleChangeCountry = (newValue) => {
        let newObject = {
            id: newValue.ctrycode,
            ctrycode: newValue.ctrycode,
            ctrycname: newValue.ctrycname
        }
        setCountry(newObject);
    }

    const handleCancel = () => {
        setIsOpenDialog(false);
    }
    return (
        <Dialog open={isOpenDialog} maxWidth="md">
            <DialogTitle style={{ color: "#1381B9", fontFamily: 'sans-serif' }}>Add Customer</DialogTitle>
            <DialogContent dividers>
                <Paper component="form" className={classes.paper}>
                    <Grid container spacing={3}>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="party_name">
                                        <span className={classes.mandatoryField}>*</span>
                                        Party Name
                                    </label>
                                </Typography>
                                <TextField
                                    id="partyName"
                                    color="primary"
                                    variant="outlined"
                                    value={partyName}
                                    onChange={(e) => setPartyName(e.target.value)}
                                    className={classes.inputField}
                                    placeholder="Party Name"
                                />
                                {formValidator.current.message('Party Name', partyName, 'required', { className: classes.validateStyle })}
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="contact_name">
                                        Contact Name
                                    </label>
                                </Typography>
                                <TextField
                                    id="contact"
                                    color="primary"
                                    variant="outlined"
                                    onChange={(e) => handleChangeCustomer('contact_name', e.target.value)}
                                    className={classes.inputField}
                                    placeholder="Contact Name"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="vat_no">
                                        VAT No.
                                    </label>
                                </Typography>
                                <TextField
                                    id="VAT"
                                    color="primary"
                                    variant="outlined"
                                    onChange={(e) => handleChangeCustomer('party_vatno', e.target.value)}
                                    className={classes.inputField}
                                    placeholder="VAT No."
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="ein">
                                        EIN No.
                                    </label>
                                </Typography>
                                <TextField
                                    id="ein"
                                    color="primary"
                                    variant="outlined"
                                    onChange={(e) => handleChangeCustomer('party_ein', e.target.value)}
                                    className={classes.inputField}
                                    placeholder="EIN No."
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="email">
                                        <span className={classes.mandatoryField}>*</span>
                                        Email
                                    </label>
                                </Typography>
                                <TextField
                                    id="Email"
                                    color="primary"
                                    variant="outlined"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={classes.inputField}
                                    placeholder="Email"
                                />
                                {formValidator.current.message('Email', email, 'required', { className: classes.validateStyle })}
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="add1">
                                        Address 1
                                    </label>
                                </Typography>
                                <TextField
                                    id="add1"
                                    color="primary"
                                    variant="outlined"
                                    onChange={(e) => handleChangeCustomer('party_addr1', e.target.value)}
                                    className={classes.inputField}
                                    placeholder="Address 1"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="add2">
                                        Address 2
                                    </label>
                                </Typography>
                                <TextField
                                    id="add2"
                                    color="primary"
                                    variant="outlined"
                                    onChange={(e) => handleChangeCustomer('party_addr2', e.target.value)}
                                    className={classes.inputField}
                                    placeholder="Address 2"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="city">
                                        City
                                    </label>
                                </Typography>
                                <TextField
                                    id="city"
                                    color="primary"
                                    variant="outlined"
                                    onChange={(e) => handleChangeCustomer('party_city', e.target.value)}
                                    className={classes.inputField}
                                    placeholder="City"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="state">
                                        <span className={classes.mandatoryField}>*</span>
                                        State
                                    </label>
                                </Typography>
                                <TextField
                                    id="state"
                                    color="primary"
                                    variant="outlined"
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}
                                    className={classes.inputField}
                                    placeholder="State"
                                />
                                {formValidator.current.message('State', state, 'required', { className: classes.validateStyle })}
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="zip">
                                        <span className={classes.mandatoryField}>*</span>
                                        Zip
                                    </label>
                                </Typography>
                                <TextField
                                    id="zip"
                                    color="primary"
                                    variant="outlined"
                                    value={zip}
                                    onChange={(e) => setZip(e.target.value)}
                                    className={classes.inputField}
                                    placeholder="Zip"
                                />
                                {formValidator.current.message('Zip', zip, 'required', { className: classes.validateStyle })}
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="telephone">
                                        <span className={classes.mandatoryField}>*</span>
                                        Telephone
                                    </label>
                                </Typography>
                                <TextField
                                    id="telephone"
                                    color="primary"
                                    variant="outlined"
                                    value={telephone}
                                    onChange={(e) => setTelephone(e.target.value)}
                                    className={classes.inputField}
                                    placeholder="Telephone"
                                />
                                {formValidator.current.message('Telephone', telephone, 'required', { className: classes.validateStyle })}
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth variant="outlined">
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="country">
                                        <span className={classes.mandatoryField}>*</span>
                                        Country
                                    </label>
                                </Typography>
                                <Autocomplete
                                    disableClearable
                                    id="country-select"
                                    value={country}
                                    options={countries}
                                    getOptionLabel={(option) => option.ctrycname}
                                    getOptionSelected={(option, value) => value.ctrycode === option.ctrycode}
                                    onChange={(e, newValue) => handleChangeCountry(newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            required
                                            {...params}
                                            placeholder="Country"
                                            variant="outlined"
                                            margin="normal"
                                            className={classes.inputField}
                                        />
                                    )}
                                />
                                {formValidator.current.message('Country', country, 'required', { className: classes.validateStyle })}
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                <Typography className={classes.accordianExpandedTitle}>
                                    <label htmlFor="isactive">
                                        Is Active
                                    </label>
                                </Typography>
                                <Checkbox
                                    onChange={(e) => handleChangeCustomer('isactive', e.target.checked)}
                                    color="primary"
                                    style={{ marginTop: '-26px', marginLeft: '-66px' }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary">Save</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddCustomerModal;